import { render, staticRenderFns } from "./ptTableRowSlots.vue?vue&type=template&id=052eb478&lang=pug&"
import script from "./ptTableRowSlots.vue?vue&type=script&lang=js&"
export * from "./ptTableRowSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports